import a11y from './svg/a11y.svg';
import address_book from './svg/address_book.svg';
import air_conditioner from './svg/air_conditioner.svg';
import altitude from './svg/altitude.svg';
import animals from './svg/animals.svg';
import arrow_angle_down from './svg/arrow_angle_down.svg';
import arrow_angle_left from './svg/arrow_angle_left.svg';
import arrow_angle_right from './svg/arrow_angle_right.svg';
import arrow_angle_up from './svg/arrow_angle_up.svg';
import arrow_contract from './svg/arrow_contract.svg';
import arrow_expand from './svg/arrow_expand.svg';
import arrow_long_down from './svg/arrow_long_down.svg';
import arrow_long_left from './svg/arrow_long_left.svg';
import arrow_long_right from './svg/arrow_long_right.svg';
import arrow_long_up from './svg/arrow_long_up.svg';
import arrow_long_up_down from './svg/arrow_long_up_down.svg';
import arrow_up_right from './svg/arrow_up_right.svg';
import baby_park from './svg/baby_park.svg';
import bar from './svg/bar.svg';
import barcode_rectangle from './svg/barcode_rectangle.svg';
import bed_double from './svg/bed_double.svg';
import bed_single from './svg/bed_single.svg';
import bell from './svg/bell.svg';
import bicycle from './svg/bicycle.svg';
import bicycle_e_bike from './svg/bicycle_e_bike.svg';
import bicycle_fat from './svg/bicycle_fat.svg';
import bicycle_road from './svg/bicycle_road.svg';
import bicycle_trekking from './svg/bicycle_trekking.svg';
import book from './svg/book.svg';
import book_open from './svg/book_open.svg';
import bookmark from './svg/bookmark.svg';
import bookmark_fill from './svg/bookmark_fill.svg';
import breakfast from './svg/breakfast.svg';
import browser from './svg/browser.svg';
import bus from './svg/bus.svg';
import cableway from './svg/cableway.svg';
import calendar from './svg/calendar.svg';
import calendar_delete from './svg/calendar_delete.svg';
import cap from './svg/cap.svg';
import car from './svg/car.svg';
import carousel from './svg/carousel.svg';
import cart from './svg/cart.svg';
import cart_plus from './svg/cart_plus.svg';
import chairlift_eight from './svg/chairlift_eight.svg';
import chairlift_four from './svg/chairlift_four.svg';
import chairlift_six from './svg/chairlift_six.svg';
import chairlift_three from './svg/chairlift_three.svg';
import chairlift_two from './svg/chairlift_two.svg';
import chart_mixed from './svg/chart_mixed.svg';
import chart_pie from './svg/chart_pie.svg';
import chat from './svg/chat.svg';
import check from './svg/check.svg';
import check_circle_outline from './svg/check_circle_outline.svg';
import check_list from './svg/check_list.svg';
import check_square_outline from './svg/check_square_outline.svg';
import meal from './svg/chef_hat.svg';
import class_first from './svg/class_first.svg';
import class_first_second from './svg/class_first_second.svg';
import class_second from './svg/class_second.svg';
import clock from './svg/clock.svg';
import clock_hourglass from './svg/clock_hourglass.svg';
import code from './svg/code.svg';
import coin from './svg/coin.svg';
import coins from './svg/coins.svg';
import compass from './svg/compass.svg';
import concierge from './svg/concierge.svg';
import copy from './svg/copy.svg';
import crown from './svg/crown.svg';
import cubes from './svg/cubes.svg';
import direction_forward_square from './svg/direction_forward_square.svg';
import direction_return_square from './svg/direction_return_square.svg';
import district from './svg/district.svg';
import do_not_enter from './svg/do_not_enter.svg';
import price from './svg/dollar_circle.svg';
import door from './svg/door_closed.svg';
import download from './svg/download.svg';
import drag from './svg/drag.svg';
import dumbbell from './svg/dumbbell.svg';
import easy_rent from './svg/easy_rent.svg';
import edit from './svg/edit.svg';
import email from './svg/email.svg';
import erase from './svg/erase.svg';
import euro from './svg/euro.svg';
import eye from './svg/eye.svg';
import eye_hide from './svg/eye_hide.svg';
import female from './svg/female.svg';
import file from './svg/file.svg';
import invoice from './svg/file_invoice.svg';
import file_2 from './svg/file_lines.svg';
import file_pdf from './svg/file_pdf.svg';
import file_slash from './svg/file_slash.svg';
import filter from './svg/filter.svg';
import folder from './svg/folder.svg';
import fork from './svg/fork.svg';
import forward from './svg/forward.svg';
import full_screen from './svg/full_screen.svg';
import gear from './svg/gear.svg';
import globe from './svg/globe.svg';
import gondola from './svg/gondola.svg';
import google_locker from './svg/google_locker.svg';
import grid_plus from './svg/grid_plus.svg';
import guest_card from './svg/guest_card.svg';
import home from './svg/home.svg';
import hotel from './svg/hotel.svg';
import ice_skating from './svg/ice_skating.svg';
import card_badge from './svg/id_card_clip.svg';
import identity_document from './svg/identity_document.svg';
import gallery from './svg/images.svg';
import info_square_outline from './svg/info_square_outline.svg';
import key from './svg/key.svg';
import lang from './svg/lang.svg';
import layer from './svg/layer.svg';
import list from './svg/list.svg';
import lock from './svg/lock.svg';
import male from './svg/male.svg';
import map from './svg/map.svg';
import map_multi_pin from './svg/map_multi_pin.svg';
import map_pin from './svg/map_pin.svg';
import markdown from './svg/markdown.svg';
import memberships_3 from './svg/memberships_3.svg';
import menu_bars from './svg/menu_bars.svg';
import minibar from './svg/minibar.svg';
import minus from './svg/minus.svg';
import mobile from './svg/mobile.svg';
import mode_dark from './svg/mode_dark.svg';
import mode_light from './svg/mode_light.svg';
import money from './svg/money.svg';
import money_transfer from './svg/money_transfer.svg';
import more from './svg/more.svg';
import mountain from './svg/mountain.svg';
import mountains from './svg/mountains.svg';
import mouse_pointer from './svg/mouse_pointer.svg';
import music from './svg/music.svg';
import network from './svg/network.svg';
import no_smoking from './svg/no_smoking.svg';
import not_result from './svg/not_result.svg';
import open from './svg/open.svg';
import paragliding from './svg/paragliding.svg';
import partner from './svg/partner.svg';
import passport from './svg/passport.svg';
import pay_tv from './svg/pay_tv.svg';
import payment_info from './svg/payment_info.svg';
import percent from './svg/percent.svg';
import phone from './svg/phone.svg';
import pickup_card from './svg/pickup_card.svg';
import pickup_snowit from './svg/pickup_snowit.svg';
import pin from './svg/pin.svg';
import plane from './svg/plane.svg';
import plus from './svg/plus.svg';
import plus_circle_fill from './svg/plus_circle_fill.svg';
import plus_hexagon_outline from './svg/plus_hexagon_outline.svg';
import print from './svg/print.svg';
import qrcode from './svg/qrcode.svg';
import question_circle_fill from './svg/question_circle_fill.svg';
import question_circle_outline from './svg/question_circle_outline.svg';
import race from './svg/race.svg';
import radar from './svg/radar.svg';
import receipt from './svg/receipt.svg';
import refresh from './svg/refresh.svg';
import revert from './svg/revert.svg';
import road from './svg/road.svg';
import rotate_left from './svg/rotate_left.svg';
import rotate_right from './svg/rotate_right.svg';
import route from './svg/route.svg';
import sauna from './svg/sauna.svg';
import save_time from './svg/save_time.svg';
import search from './svg/search.svg';
import search_fast from './svg/search_fast.svg';
import search_snowitcard from './svg/search_snowitcard.svg';
import select from './svg/select.svg';
import settings from './svg/settings.svg';
import category from './svg/shapes.svg';
import share_android from './svg/share_android.svg';
import shield_check from './svg/shield_check.svg';
import shop_bag from './svg/shop_bag.svg';
import shop_bags from './svg/shop_bags.svg';
import shop_point from './svg/shop_point.svg';
import shuttle from './svg/shuttle.svg';
import sidebar from './svg/sidebar.svg';
import ski from './svg/ski.svg';
import ski_lift from './svg/ski_lift.svg';
import ski_nordic from './svg/ski_nordic.svg';
import skiwork from './svg/skiwork.svg';
import slope_flag from './svg/slope_flag.svg';
import snow from './svg/snow.svg';
import snow_2 from './svg/snow_2.svg';
import snowboard from './svg/snowboard.svg';
import spa from './svg/spa.svg';
import sport from './svg/sport.svg';
import starred_restaurant from './svg/starred_restaurant.svg';
import sun from './svg/sun.svg';
import swatchbook from './svg/swatchbook.svg';
import swimming_pool from './svg/swimming_pool.svg';
import table_cells_large from './svg/table_cells_large.svg';
import tag from './svg/tag.svg';
import tailored_holiday from './svg/tailored_holiday.svg';
import tenant from './svg/tenant.svg';
import toboggan_track from './svg/toboggan_track.svg';
import tour_operator from './svg/tour_operator.svg';
import trash from './svg/trash.svg';
import trash_undo from './svg/trash_undo.svg';
import trophy from './svg/trophy.svg';
import truck from './svg/truck.svg';
import truck_fill from './svg/truck_fill.svg';
import tv from './svg/tv.svg';
import tv_sat from './svg/tv_sat.svg';
import typo_bold from './svg/typo_bold.svg';
import typo_h2 from './svg/typo_h2.svg';
import typo_h3 from './svg/typo_h3.svg';
import typo_italic from './svg/typo_italic.svg';
import typo_link from './svg/typo_link.svg';
import typo_list_ol from './svg/typo_list_ol.svg';
import typo_list_ul from './svg/typo_list_ul.svg';
import typo_text from './svg/typo_text.svg';
import unhappy from './svg/unhappy.svg';
import upload from './svg/upload.svg';
import user from './svg/user.svg';
import user_circle from './svg/user_circle.svg';
import group from './svg/user_group.svg';
import user_profile from './svg/user_profile.svg';
import utensils from './svg/utensils.svg';
import venue from './svg/venue.svg';
import wallet from './svg/wallet.svg';
import wallet_apple from './svg/wallet_apple.svg';
import wallet_coins from './svg/wallet_coins.svg';
import wallet_google from './svg/wallet_google.svg';
import webcam from './svg/webcam.svg';
import wheelchair from './svg/wheelchair.svg';
import wifi from './svg/wifi.svg';
import wreath_close from './svg/wreath_close.svg';
import wreath_open from './svg/wreath_open.svg';
import xmark from './svg/xmark.svg';
import xmark_circle_fill_2 from './svg/xmark_circle_fill_2.svg';
import xmark_circle_outline from './svg/xmark_circle_outline.svg';
import xmark_square_outline from './svg/xmark_square_outline.svg';
import zone from './svg/zone.svg';

const svgs = {
  'e-bike': bicycle_e_bike,
  'road-bike': bicycle_road,
  'trekking-bike': bicycle_trekking,
  guest_card,
  a11y,
  address_book,
  adrenaline: ski,
  adult: user,
  air_conditioner,
  air_conditioning: air_conditioner,
  altitude,
  animals,
  arrow_angle_down,
  arrow_angle_left,
  arrow_angle_right,
  arrow_angle_up,
  arrow_contract,
  arrow_expand,
  arrow_long_down,
  arrow_long_left,
  arrow_long_right,
  arrow_long_up,
  arrow_sort: arrow_long_up_down,
  arrow_up_right,
  baby: user,
  baby_park,
  bar,
  barcode_rectangle,
  bed_double,
  bed_single,
  bell,
  bicycle,
  bike_fat: bicycle_fat,
  block: table_cells_large,
  bold: typo_bold,
  book,
  book_open_cover: book_open,
  bookmark,
  bookmark_fill,
  breakfast: breakfast,
  browser,
  bus,
  cableway,
  calendar,
  calendar_2: calendar,
  calendar_day: calendar,
  calendar_delete,
  calendar_week: calendar,
  cap,
  car,
  card_badge,
  carousel,
  cart,
  cart_plus,
  category,
  chairlift_eight,
  chairlift_four,
  chairlift_six,
  chairlift_three,
  chairlift_two,
  chart_mixed,
  chart_pie,
  chat,
  check,
  check_circle_2: check_circle_outline,
  check_list,
  check_square: check_square_outline,
  clock,
  clock_hourglass,
  close: xmark,
  close_2: xmark_circle_fill_2,
  close_circle: xmark_circle_outline,
  close_square: xmark_square_outline,
  code,
  coin,
  coins,
  compass,
  concierge,
  copy,
  croissant: breakfast,
  cross_country: ski_nordic,
  crown,
  disabled: do_not_enter,
  disco: music,
  district,
  door,
  download,
  drag_vertical: drag,
  e_bike: bicycle_e_bike,
  easy_rent,
  edit,
  email,
  erase,
  euro,
  eye_hide,
  eye_show: eye,
  female,
  file,
  file_2,
  file_pdf,
  file_slash,
  filter,
  first_class: class_first,
  first_second_class: class_first_second,
  folder,
  forward_square: direction_forward_square,
  free_cancellation: check_circle_outline,
  full_board: utensils,
  full_screen,
  gallery,
  gear,
  globe,
  goal_daycount: calendar,
  goal_distance: route,
  goal_district: map_pin,
  goal_districtscount: map_multi_pin,
  goal_heightdifference: altitude,
  goal_maxaltitude: slope_flag,
  goal_skitime: clock,
  goal_turnstilescount: cableway,
  gondola,
  google_locker,
  grid_plus,
  group,
  gym: dumbbell,
  h2: typo_h2,
  h3: typo_h3,
  half_board: fork,
  home,
  ice_cart: race,
  ice_skating,
  identity_document,
  import_export: arrow_long_up_down,
  info_square: info_square_outline,
  invoice,
  italic: typo_italic,
  junior: user,
  key,
  lang,
  layer,
  link: typo_link,
  list,
  list_ol: typo_list_ol,
  list_ul: typo_list_ul,
  lock,
  male,
  many_hotels: hotel,
  map,
  map_multi_pin,
  map_pin,
  map_pin_2: map_pin,
  markdown,
  meal,
  memberships_3,
  menu: menu_bars,
  minibar,
  minus,
  mobile,
  mode_dark,
  mode_light,
  money,
  money_transfer,
  more,
  mountain,
  mountain_2: mountains,
  mouse_pointer,
  music,
  network,
  no_fixed_cost: coins,
  no_smoking,
  non_refundable: coins,
  not_result,
  one_booking: receipt,
  open,
  option: check_list,
  palette: swatchbook,
  paragliding,
  partner,
  passport,
  payTv: pay_tv,
  payment_info,
  percent,
  phone,
  pickup: pickup_card,
  pickup_snowit,
  pin,
  plane,
  plus,
  plus_circle: plus_circle_fill,
  plus_hexagon: plus_hexagon_outline,
  price,
  print,
  products: cubes,
  qrcode,
  question: question_circle_outline,
  question_circle: question_circle_fill,
  refresh,
  refund: money_transfer,
  restaurant: utensils,
  restrict: do_not_enter,
  return_square: direction_return_square,
  revert,
  road,
  road_bike: bicycle_road,
  room_service: concierge,
  rotate_left,
  rotate_right,
  route,
  sauna,
  save_time,
  search,
  search_fast,
  search_snowitcard,
  second_class: class_second,
  select,
  seo: radar,
  settings,
  share: share_android,
  shield_check,
  shop: shop_bag,
  shop_bag_2: shop_bags,
  shop_point,
  shopping: shop_bags,
  shuttle,
  sidebar,
  ski,
  ski_cable: cableway,
  ski_lift,
  ski_nordic,
  ski_route: route,
  skilift: ski_lift,
  skip: forward,
  skiwork,
  slope_flag,
  snow,
  snow_2,
  snowboard,
  spa,
  sport,
  starred_restaurant,
  summer: sun,
  swimming_pool,
  tag,
  tailored_holiday,
  task: check_list,
  tenant,
  text: typo_text,
  toboggan_track,
  tour_operator,
  trash,
  trash_undo,
  trekking_bike: bicycle_trekking,
  trophy,
  truck,
  truck_2: truck_fill,
  tv,
  tvSat: tv_sat,
  unhappy,
  upload,
  user,
  user_circle,
  user_profile,
  venue,
  wallet,
  wallet_apple,
  wallet_coins,
  wallet_google,
  webcam,
  wellness: spa,
  wheelchair,
  wifi,
  world_cup: trophy,
  wreath_close,
  wreath_open,
  zone,
} as const;

export type SvgIconsList = keyof typeof svgs;
export default svgs;
